module.exports = __webpack_public_path__ + "img/tw.a86d62f6.svg";